<template>
  <div>
    <b-input-group>
      <b-form-input
          v-model.number="ranges[0]"
          type="number"
      ></b-form-input>
      <b-input-group-prepend is-text><b>-</b></b-input-group-prepend>
      <b-form-input
          v-model.number="ranges[1]"
          type="number"
      ></b-form-input>
    </b-input-group>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'number-range',
  props: {
    value: {
      type: Array,
      default: undefined,
    }
  },
  data() {
    return {
      lodash: _,
      ranges: this.value || [],
    }
  },
  watch: {
    ranges: function (vals) {
      if(vals === undefined){
        return;
      }
      let anyEmpty = vals.filter(val => val === undefined ||  val === null || val === '' ).length > 0 || vals.length < 2
      if(anyEmpty){
        this.$emit('input', [])
      }
      if (vals.length === 2 && !anyEmpty) {
        this.$emit('input', vals)
      }
    },
    value(val){
      if(val == undefined){
        this.ranges = []
      }
    }
  },
}
</script>

<style scoped>

</style>